export default function Header() {
  return (
    <header className="sticky top-0 z-50 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 border-b border-slate-700/50 shadow-xl">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            {/* Logo with glow effect */}
            <div className="relative">
              <div className="absolute inset-0 bg-blue-500/30 blur-xl rounded-full" />
              <img
                src="/images/democrat.jpg"
                alt="Democrat"
                className="relative w-11 h-11 rounded-xl object-cover border-2 border-blue-400/30 shadow-lg"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
            <div>
              <h1 className="text-xl sm:text-2xl font-extrabold tracking-tight">
                <span className="bg-gradient-to-r from-blue-400 via-blue-300 to-cyan-300 bg-clip-text text-transparent">
                  2026 House
                </span>
                <span className="text-white ml-1.5">Victory Map</span>
              </h1>
              <p className="text-xs sm:text-sm text-slate-400 font-medium">
                Democratic Campaign Intelligence
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2 sm:gap-3">
            <a
              href="/guide/"
              className="flex items-center px-3 py-1.5 rounded-full bg-blue-500/10 border border-blue-400/30 text-xs font-semibold text-blue-200 hover:bg-blue-500/20 transition-colors"
            >
              2026 guide
            </a>
            <div className="hidden sm:flex items-center px-3 py-1.5 rounded-full bg-slate-700/50 border border-slate-600">
              <span className="text-xs font-semibold text-slate-300 uppercase tracking-wider">Independent model</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
